import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { cleanProviderForDisplay, type Provider } from "@/data/heallexa";
import { buildProviderSlug } from "@/lib/provider-slug";
import { getProviderByNpiFn } from "./-providers.$id.functions";

// Short, no-dash, shareable alias: /provider/{namewithoutseparators}{npi}.
// The trailing 10 digits are the real lookup key (NPI is unique); the name
// prefix is cosmetic only. This is a permanent redirect to the canonical
// rich-SEO-slug page at /providers/$id — not a second copy of the profile UI.
// Providers with no NPI on file simply have no short alias.
const NPI_RE = /(\d{10})$/;

export const Route = createFileRoute("/provider/$slug")({
  loader: async ({ params }) => {
    const match = params.slug.match(NPI_RE);
    if (!match) throw notFound();
    const npi = match[1];
    const row = await getProviderByNpiFn({ data: { npi } });
    if (!row) throw notFound();
    const provider = cleanProviderForDisplay(row as Provider);
    const canonicalSlug = buildProviderSlug(provider);
    throw redirect({ to: "/providers/$id", params: { id: canonicalSlug }, search: {}, statusCode: 301 });
  },
});
